import NBType, { InferType } from '@netbase/nb-type'

const InsightGroupInfoSchema = NBType.object().shape('InsightGroupInfoSchema', {
  dataIdx: NBType.number(),
  datasetIdx: NBType.number(),
  insightIdx: NBType.number()
})

export default InsightGroupInfoSchema
export type InsightGroupInfo = InferType<typeof InsightGroupInfoSchema>
// RESERVE BELOW
